import React from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
} from 'react-native';
import { MARKETPLACE_COLORS } from '@/constants/residents/marketplaceColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { BottomSheetModal } from './shared';

const ReportIcon = RESIDENTS_SVG_COMPONENTS.FINISH;
const ReplyArrowIcon = RESIDENTS_SVG_COMPONENTS.REPLY_ARROW;

interface MessageActionsModalProps {
  visible: boolean;
  onClose: () => void;
  onReply: () => void;
  onReportConversation: () => void;
}

export const MessageActionsModal: React.FC<MessageActionsModalProps> = ({
  visible,
  onClose,
  onReply,
  onReportConversation,
}) => {
  const handleReply = () => {
    onClose();
    onReply();
  };

  const handleReportConversation = () => {
    onClose();
    onReportConversation();
  };

  return (
    <BottomSheetModal
      visible={visible}
      onClose={onClose}
      title="Actions"
    >
      {/* Actions List */}
      <View style={styles.actionsList}>
        {/* Reply Action */}
        <TouchableOpacity
          style={styles.actionItem}
          onPress={handleReply}
          activeOpacity={0.7}
        >
          <ReplyArrowIcon width={20} height={20} color={MARKETPLACE_COLORS.textPrimary} />
          <Text style={styles.actionText}>Reply</Text>
        </TouchableOpacity>

        {/* Separator */}
        <View style={styles.separator} />

        {/* Report Conversation Action */}
        <TouchableOpacity
          style={styles.actionItem}
          onPress={handleReportConversation}
          activeOpacity={0.7}
        >
          <ReportIcon width={20} height={20} color={MARKETPLACE_COLORS.textPrimary} />
          <Text style={styles.actionText}>Report conversation</Text>
        </TouchableOpacity>
      </View>
    </BottomSheetModal>
  );
};

const styles = StyleSheet.create({
  actionsList: {
    gap: 4,
  },
  actionItem: {
    flexDirection: 'row',
    alignItems: 'center',
    height: 40,
    gap: 6,
  },
  actionText: {
    fontSize: 14,
    fontWeight: '400',
    color: MARKETPLACE_COLORS.textPrimary,
    lineHeight: 17.5,
    flex: 1,
  },
  separator: {
    height: 1,
    backgroundColor: MARKETPLACE_COLORS.dividerGray,
  },
});
